import { useState } from 'react';

// Drop the address from the visible URL once it has been consumed. It is PII
// that would otherwise linger in browser history, in `Referer` headers and in
// anything that captures the page URL — notably the session recorder, which
// cannot be started until the URL is clean (see `components/Fullstory`).
// `params` is a snapshot taken before this runs, so the pre-fill above is
// unaffected.
const stripEmailFromUrl = () => {
  const url = new URL(window.location.href);

  if (!url.searchParams.has('email')) {
    return;
  }

  url.searchParams.delete('email');
  window.history.replaceState(window.history.state, '', url.toString());
};

const autofillEmail = (params, action = () => {}) => {
  const input = document.getElementById('username-input');
  const email = params.get('email');
  if (input && email) {
    // we get email value in UTF-8
    const decodeEmail = decodeURIComponent(email);
    input.value = decodeEmail;
    if (input.value === decodeEmail) {
      stripEmailFromUrl();
      action(true);
    }
  }
};
const useRedirect = () => {
  const [isAutofillEmail, setIsAutofillEmail] = useState(false);
  const { pathname, search } = window.location;
  const params = new URLSearchParams(search);

  switch (pathname) {
    case '/resetpassword':
      if (!isAutofillEmail) {
        setTimeout(() => {
          autofillEmail(params, setIsAutofillEmail);
        });
      }
      return { initialForm: 'resetPassword' };
    case '/': {
      if (!isAutofillEmail) {
        setTimeout(() => {
          autofillEmail(params, setIsAutofillEmail);
        });
      }
      return { initialForm: 'signIn' };
    }
    default:
      return { initialForm: 'signIn' };
  }
};

export default useRedirect;
